import { Component, inject, ViewChild } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';
import { ConfirmDialogComponent } from '../components/confirm-dialog.component';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-layout',
    standalone: true,
    styles: `
        .active{
            --tw-outline-style: none;
            outline-style: none;
            color: var(--menu-active-fg);
            background-color: rgb(from var(--menu-active-bg) r g b / 0.8);
            background-size: auto, calc(var(--noise) * 100%);
            background-image: none, var(--fx-noise);
        }
    `,
    imports: [RouterOutlet, RouterLink, RouterLinkActive, ConfirmDialogComponent],
    templateUrl: './layout.component.html',
})
export class LayoutComponent {
    @ViewChild('logoutDialog') logoutDialog!: ConfirmDialogComponent;
    authService = inject(AuthService);

    logout(): void {
        this.logoutDialog.open();
    }

    onLogoutConfirmed(done: (shouldClose?: boolean) => void): void {
        this.authService
            .logout()
            .pipe(finalize(() => done(true)))
            .subscribe();
    }
}
